import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

function FinansOzetKarti({
  toplamGelir,
  toplamGider,
  netBakiye,
  gelirYuzde,
  paraFormatla,
  oncekiDonemNet = 0,
  enYogunKategori = null,
  islemSayisi = 0,
  ortakHarcamaToplami = 0,
  onlyHero = false,
  smartMessage = "",
  amountsHidden = false,
  onToggleAmounts,
}) {
  const { t } = useLanguage();
  const giderDeg = 100 - gelirYuzde;
  const C = 502.65; // 2πr where r=80
  const saglik = toplamGelir === 0 ? 0 : Math.max(0, Math.min(100, ((toplamGelir - toplamGider) / toplamGelir) * 100));

  return (
    <>
      <div className="financeHeroCard">
        <div className="financeHeroTop">
          <div className="financeHeroBalanceBlock">
            <div className="financeHeroTitleRow">
              <span className="financeEyebrow">{t("finance.summaryTitle")}</span>
              <button
                type="button"
                className={`financePrivacyToggle ${amountsHidden ? "isHidden" : ""}`}
                onClick={onToggleAmounts}
                aria-pressed={amountsHidden}
                aria-label={amountsHidden ? (t("finance.privacy.show") || "Tutarları göster") : (t("finance.privacy.hide") || "Tutarları gizle")}
                title={amountsHidden ? (t("finance.privacy.show") || "Tutarları göster") : (t("finance.privacy.hide") || "Tutarları gizle")}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6-9.5-6-9.5-6Z" />
                  <circle cx="12" cy="12" r="2.8" />
                  {amountsHidden && <path className="privacySlash" d="M4 4l16 16" />}
                </svg>
              </button>
            </div>
            <h2 className={netBakiye > 0 ? "amountGreen" : netBakiye < 0 ? "amountRed" : ""}>{paraFormatla(netBakiye)}</h2>
            <p>{t("finance.netBalancePeriod")}</p>
          </div>
          {smartMessage && (
            <div className="financeHeroSmartMessage">
              <span>✨</span>
              <b>{smartMessage}</b>
            </div>
          )}
        </div>
        <div className="financeHeroStats">
          <div><span>{t("finance.income")}</span><b className="green">{paraFormatla(toplamGelir)}</b></div>
          <div><span>{t("finance.expense")}</span><b className="red">{paraFormatla(toplamGider)}</b></div>
          <div><span>{t("finance.transaction")}</span><b>{islemSayisi}</b></div>
        </div>
      </div>

      {false && !onlyHero && (
  <div className="summaryGrid proSummaryGrid">
    <div className="moneyCard income">
      <span className="moneyLabel">{t("finance.income")}</span>
      <b>{paraFormatla(toplamGelir)}</b>
    </div>
    <div className="moneyCard expense">
      <span className="moneyLabel">{t("finance.expense")}</span>
      <b>{paraFormatla(toplamGider)}</b>
    </div>
    <div className="moneyCard net">
      <span className="moneyLabel">Net</span>
      <b>{paraFormatla(netBakiye)}</b>
    </div>
  </div>
)}

      {/* Geçici olarak gizlendi: En yoğun gider / Aile harcamaları / Finans sağlığı */}
      {false && !onlyHero && (
      <div className="financeInsightGrid">
        <div className="financeInsightCard">
          <span className="financeInsightIcon">🏆</span>
          <div>
            <small>{t("finance.topExpense")}</small>
            <strong>{enYogunKategori?.kategori || t("common.noneYet")}</strong>
            <span>{enYogunKategori ? paraFormatla(enYogunKategori.tutar) : t("finance.visibleAfterExpense")}</span>
          </div>
        </div>
        <div className="financeInsightCard">
          <span className="financeInsightIcon">💸</span>
          <div>
            <small>{t("finance.familyExpenses")}</small>
            <strong>{paraFormatla(ortakHarcamaToplami)}</strong>
            <span>{t("finance.thisMonthSharedTotal")}</span>
          </div>
        </div>
        <div className="financeInsightCard">
          <span className="financeInsightIcon">📈</span>
          <div>
            <small>{t("finance.health")}</small>
            <strong>{Math.round(saglik)}%</strong>
            <span>{saglik >= 30 ? t("finance.underControl") : t("finance.needsAttention")}</span>
          </div>
        </div>
      </div>
      )}

      {/* Geçici olarak gizlendi: pasta grafik */}
      {false && !onlyHero && (
      <div className="pieWrap premiumPieWrap">
        <div className="pieOuter">
          <svg viewBox="0 0 200 200" className="pieSvg">
            <circle cx="100" cy="100" r="80" fill="none" stroke="rgba(148,163,184,0.18)" strokeWidth="30"/>
            <circle cx="100" cy="100" r="80" fill="none" stroke="#ef4444" strokeWidth="30"
              strokeDasharray={`${(giderDeg/100)*C} ${C}`}
              strokeDashoffset="0" transform="rotate(-90 100 100)"
              style={{transition:"stroke-dasharray 0.6s ease"}}/>
            <circle cx="100" cy="100" r="80" fill="none" stroke="#22c55e" strokeWidth="30"
              strokeDasharray={`${(gelirYuzde/100)*C} ${C}`}
              strokeDashoffset={`-${(giderDeg/100)*C}`}
              transform="rotate(-90 100 100)"
              style={{transition:"stroke-dasharray 0.6s ease"}}/>
            <text x="100" y="94" textAnchor="middle" fill="currentColor" fontSize="15" fontWeight="900">
              {Math.round(gelirYuzde)}%
            </text>
            <text x="100" y="112" textAnchor="middle" fill="currentColor" opacity="0.62" fontSize="11" fontWeight="700">
              Gelir
            </text>
          </svg>
          <div className="pieLegend">
            <div className="pieLegendItem">
              <span className="pieDot" style={{background:"#22c55e"}}/>
              <div><small>{t("finance.incomeRatio")}</small><strong>{paraFormatla(toplamGelir)}</strong></div>
            </div>
            <div className="pieLegendItem">
              <span className="pieDot" style={{background:"#ef4444"}}/>
              <div><small>{t("finance.expenseRatio")}</small><strong>{paraFormatla(toplamGider)}</strong></div>
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
}

export default FinansOzetKarti;
